// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__hyk6C","loader":"loader_loader__f678D","load":"loader_load__HQkG5"};